import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'hooks';
import { CustomInput } from 'reactstrap'
import { Topography, Button, Input, InputError, DropZone, InputLabel, Radio } from 'components/ui';
import DatePickerUI from 'components/ui/DatePicker/DatePicker';
import { Form, Field } from 'react-final-form';
import { Validators, Parsers, getSnapshotById, dataURLtoFile } from 'utils';
import moment from 'moment'
import SignatureCanvas from 'react-signature-canvas'
import { submitHippaForm, updateDocumentStatus, hippaFormReset } from 'store/actions/hippa.action'
import { hippaSelector } from 'store/reducers/hippa.reducer'
import { PreloaderWrapper } from 'components/containers';
import Alert from 'components/ui/Alert/Alert';
import image9 from 'assets/images/image9.svg';
import image10 from 'assets/images/image10.svg';
import './add_digital_signature.scss';
import request_guidance from 'assets/images/request_guidance.gif';
import { api2 } from 'store/apis';
import axios from 'axios';
import rectangleBg from 'assets/images/background.svg';
import link_expire from 'assets/images/link_expire.gif';
import ExpiredLink from 'components/containers/ExpiredLink';
import { useHippaLinkValidation } from 'hooks/useHippaLinkValidation';
import html2canvas from "html2canvas";

type GovIdFiles = {
    front: File | string | null
    back: File | string | null
}
export const ADDIGITALSIGNATURE = () => {
    const { isSubmitting, error, success } = useSelector(hippaSelector)

    const [isDrawMode, setDrawMode] = useState<boolean>(false);
    const [isSigned, setSigned] = useState<boolean>(false);
    const [fullName, setFullName] = useState<string>('');
    const [uploadType, setUploadType] = useState<'draw' | 'signature'>('draw');
    const [preview, setPreview] = useState<string | null>(null);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [errors, setErrors] = useState({
        govFront: false,
        govBack: false,
        signature: false,
        fullName: false,
        authorization: false,
    })
    let signRef: any = useRef()
    /* ---------- STATE ---------- */
    const [govtIdFiles, setFigovtIdFiles] = useState<GovIdFiles>({
        front: null,
        back: null,
    })
    const dispatch = useDispatch();

    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    // const lawFirmName = new URLSearchParams(window.location.search).get('org_name');
    const orgName = new URLSearchParams(window.location.search).get('org_name');
    const government_id = new URLSearchParams(window.location.search).get('government_id');
    const auth_document_id = new URLSearchParams(window.location.search).get('auth_document');
    const [showSuccess, setShowSuccess] = useState(false);
    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png'];
    const [signatureFile, setSignatureFile] = useState<File | null>(null);
    const [isSubmittingForm, setIsSubmittingForm] = useState(false);
    const [providerData, setProviderData] = useState<any>(null);

    const { isCheckingLink, isLinkExpired } = useHippaLinkValidation();

    const [fileSizeError, setFileSizeError] = useState<{
        front?: string;
        back?: string;
        signature?: string;
    }>({});

    const typedSigRef = useRef<HTMLDivElement | null>(null);
    const isSignatureVerified = Boolean(providerData?.verification_checklist?.hippa_verified && preview);

    useEffect(() => {
        const auth_token = new URLSearchParams(window.location.search).get('user_auth_token');
        if (!auth_token || !auth_document_id) return;

        const authDocumentId = new URLSearchParams(window.location.search).get('auth_document') || undefined;

        const fetchAuthorizationDoc = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BASE_API_URL}/dashboard/home/${auth_document_id}/record_document`,
                    {
                        headers: {
                            'authorization-token': `${auth_token}`,
                        },
                    }
                );
                // setPdfUrl(res.data.data.data.download_url);
                setPdfUrl(res?.data?.attachment?.authorization_url);
            } catch (err) {
                console.error('Download failed', err);
            }
        };

        fetchAuthorizationDoc();
    }, [auth_document_id]);

    useEffect(() => {
        if (!auth_document_id) return;

        let isMounted = true;

        const fetchPrefillData = async () => {
            try {
                const response = await api2.get(`/api/v2/provider_landing/get_auth_document?id=${auth_document_id}`)(dispatch, false, true);
                const responseData = response.data ?? response;
                if (!isMounted) return;

                const checklist = responseData?.verification_checklist || {};
                const signedDocuments = responseData?.signed_documents || {};

                console.log('Digital signature prefill data:', {
                    authDocumentId: auth_document_id,
                    checklist,
                    hasSignedAuthorization: Boolean(signedDocuments.signed_authorization_url),
                    hasGovtIdFront: Boolean(signedDocuments.govt_id_front),
                    hasGovtIdBack: Boolean(signedDocuments.govt_id_back),
                });

                setProviderData(responseData);

                if (checklist.hippa_verified && signedDocuments.signed_authorization_url) {
                    setPreview(signedDocuments.signed_authorization_url);
                    setUploadType('signature');
                }

                setFigovtIdFiles(prev => ({
                    front: checklist.govt_front_verified && signedDocuments.govt_id_front ? signedDocuments.govt_id_front : prev.front,
                    back: checklist.govt_back_verified && signedDocuments.govt_id_back ? signedDocuments.govt_id_back : prev.back,
                }));
            } catch (err) {
                console.error('Digital signature prefill error:', err);
            }
        };

        fetchPrefillData();

        return () => {
            isMounted = false;
        };
    }, [auth_document_id, dispatch]);

    /* ---------- HANDLERS ---------- */
    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        type: keyof GovIdFiles
    ) => {
        const file = e.target.files?.[0]
        if (!file) return
        if (file.size > MAX_FILE_SIZE) {
            setFileSizeError(prev => ({
                ...prev,
                [type]: 'Please upload a file less than 20 MB',
            }));
            return;
        }
        if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
            setFileSizeError(prev => ({
                ...prev,
                [type]: 'Only JPG or PNG images are allowed',
            }));
            return;
        }
        setFileSizeError(prev => ({ ...prev, [type]: undefined }));

        setFigovtIdFiles(prev => ({ ...prev, [type]: file }));
        // ✅ Clear file size/type errors
        setFileSizeError(prev => ({ ...prev, [type]: undefined }));

        // ✅ Set file
        setFigovtIdFiles(prev => ({ ...prev, [type]: file }));

        // ✅ IMPORTANT: Clear validation error so error-border is removed
        setErrors(prev => ({
            ...prev,
            ...(type === 'front' ? { govFront: false } : {}),
            ...(type === 'back' ? { govBack: false } : {}),
        }));
    }

    const removeFile = (type: keyof GovIdFiles) => {
        setFigovtIdFiles(prev => ({ ...prev, [type]: null }))
    }

    const validateForm = () => {
        const newErrors = {
            govFront: government_id === 'Required' && !govtIdFiles.front,
            govBack: government_id === 'Required' && !govtIdFiles.back,

            signature: !isSignatureVerified && (
                uploadType === 'draw'
                    ? isDrawMode && !isSigned
                    : uploadType === 'signature' && !preview
            ),

            fullName: !isSignatureVerified && uploadType === 'draw' && !fullName.trim(),
            authorization: !isAuthorized,
        };

        setErrors(newErrors);
        return !Object.values(newErrors).some(Boolean);
    };

    const getSignatureFile = async (): Promise<File | null> => {
        if (uploadType === 'draw' && !isSigned) {
            return await getTypedSignatureFile();
        }
        if (uploadType === 'draw' && signRef && !signRef.isEmpty()) {
            const dataUrl = signRef
                .getTrimmedCanvas()
                .toDataURL('image/png');

            return dataURLtoFile(dataUrl, 'image/png', 'signature.png');
        }

        if (uploadType === 'signature') {
            return signatureFile;
        }

        return null;
    };

    const buildFormData = async () => {
        const formData = new FormData();
        const signatureFile = await getSignatureFile();

        if (govtIdFiles.front) formData.append('govt_id_front', govtIdFiles.front);
        if (govtIdFiles.back) formData.append('govt_id_back', govtIdFiles.back);

        if (signatureFile) {
            formData.append('signed_authorization', signatureFile);
        } else if (isSignatureVerified && preview) {
            formData.append('signed_authorization', preview);
        }

        formData.append('authorization', String(isAuthorized));
        formData.append('auth_document_id', auth_document_id || '');
        formData.append('government_id_required', government_id || '');
        formData.append('id', auth_document_id || '');

        return formData;
    };



    const handleFinalSubmit = async () => {
        if (!validateForm()) return;

        setShowSuccess(true);
        try {
            setIsSubmittingForm(true);

            const authToken = new URLSearchParams(window.location.search).get('user_auth_token');
            const formData = await buildFormData(); // 👈 async now

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}/api/v2/provider_landing/upload_hippa_documents?digital_signature=true`,
                formData,
                {
                    headers: {
                        'authorization-token': authToken || '',
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setShowSuccess(true);
            }
        } catch (error) {
            console.error('Submission failed', error);
        } finally {
            setIsSubmittingForm(false);
        }
    };





    /* ---------- RENDER HELPERS (HTML SAME) ---------- */
    const renderUploadBox = (
        label: string,
        file: File | string | null,
        type: keyof GovIdFiles
    ) => {
        const hasError =
            government_id === 'Required' &&
            (
                (type === 'front' && !!errors.govFront) ||
                (type === 'back' && !!errors.govBack)
            );
        const isVerified = typeof file === 'string' && (
            type === 'front'
                ? providerData?.verification_checklist?.govt_front_verified
                : providerData?.verification_checklist?.govt_back_verified
        );

        return (
            <div
                className={`upload-box-front-back 
                  ${file ? 'front-back-file-uploaded' : ''} 
                  ${hasError || fileSizeError[type] ? 'error-border' : ''}`}
            >

                {!file ? (
                    <div className="upload-content-front-back upload-content">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clip-path="url(#clip0_8155_26658)">
                                    <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" fill="#00155A" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_8155_26658">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <p>
                            Drop your file here or <span>Browse</span>
                        </p>
                        <small>Supports JPG, PNG document</small>
                        <input
                            type="file"
                            className="upload-auth-input"
                            accept="image/png,image/jpeg"
                            onChange={(e) => handleFileChange(e, type)}
                        />
                        {fileSizeError[type] && (
                            <span className="upload-auth-input">{fileSizeError[type]}</span>
                        )}
                    </div>


                ) : (
                    <div className="upload-content">
                        <img
                            src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                            alt={label}
                            style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                            onLoad={(e) => {
                                if (typeof file !== 'string') {
                                    URL.revokeObjectURL((e.target as HTMLImageElement).src)
                                }
                            }}
                        />

                        {!isVerified && (
                            <span
                                className="custom_delete_icon"
                                onClick={() => removeFile(type)}
                                style={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    cursor: 'pointer',
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path d="M4.16667 1.66667V0H12.5V1.66667H16.6667V3.33333H15V15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4226C14.5996 16.5789 14.3877 16.6667 14.1667 16.6667H2.5C2.27899 16.6667 2.06702 16.5789 1.91074 16.4226C1.75446 16.2663 1.66667 16.0543 1.66667 15.8333V3.33333H0V1.66667H4.16667ZM3.33333 3.33333V15H13.3333V3.33333H3.33333ZM5.83333 5.83333H7.5V12.5H5.83333V5.83333ZM9.16667 5.83333H10.8333V12.5H9.16667V5.83333Z" fill="#E7322C" />
                                </svg>
                            </span>
                        )}
                    </div>
                )}
            </div>
        )
    }
    const setName = (name: string) => {
        setFullName(name)
    }
    const setType = (isDraw: boolean) => {
        setDrawMode(isDraw)
    }
    const handleUploadTypeChange = (type: 'draw' | 'signature') => {
        if (type === 'draw') {
            setDrawMode(false);
            setErrors(prev => ({ ...prev, signature: false }));
        } else {
            setErrors(prev => ({ ...prev, fullName: false }))
        }
        setUploadType(type);
    };
    const cropTransparentArea = (ctx: CanvasRenderingContext2D, canvas: HTMLCanvasElement) => {
        const { width, height } = canvas;
        const imageData = ctx.getImageData(0, 0, width, height).data;

        let top = height, left = width, right = 0, bottom = 0;

        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const alpha = imageData[(y * width + x) * 4 + 3];
                if (alpha > 0) {
                    top = Math.min(top, y);
                    left = Math.min(left, x);
                    right = Math.max(right, x);
                    bottom = Math.max(bottom, y);
                }
            }
        }

        const croppedWidth = right - left + 1;
        const croppedHeight = bottom - top + 1;

        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = croppedWidth;
        croppedCanvas.height = croppedHeight;

        const croppedCtx = croppedCanvas.getContext("2d")!;
        croppedCtx.drawImage(
            canvas,
            left,
            top,
            croppedWidth,
            croppedHeight,
            0,
            0,
            croppedWidth,
            croppedHeight
        );

        return croppedCanvas;
    };

    const resizeToSignatureBox = (sourceCanvas: HTMLCanvasElement) => {
        const targetWidth = 424;
        const targetHeight = 123;

        const finalCanvas = document.createElement("canvas");
        finalCanvas.width = targetWidth;
        finalCanvas.height = targetHeight;

        const ctx = finalCanvas.getContext("2d")!;

        const scale = Math.min(
            targetWidth / sourceCanvas.width,
            targetHeight / sourceCanvas.height
        );

        const newWidth = sourceCanvas.width * scale;
        const newHeight = sourceCanvas.height * scale;

        const x = (targetWidth - newWidth) / 2;
        const y = (targetHeight - newHeight) / 2;

        ctx.drawImage(sourceCanvas, x, y, newWidth, newHeight);

        return finalCanvas;
    };

    const removeBackgroundAndFixSize = (file: File) => {
        const reader = new FileReader();

        reader.onload = () => {
            const img = new Image();
            img.src = reader.result as string;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d")!;

                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;

                // 🔥 Remove white background → transparency
                for (let i = 0; i < data.length; i += 4) {
                    if (data[i] > 220 && data[i + 1] > 220 && data[i + 2] > 220) {
                        data[i + 3] = 0;
                    }
                }

                ctx.putImageData(imageData, 0, 0);

                // ✂️ Crop transparent space
                const croppedCanvas = cropTransparentArea(ctx, canvas);

                // 📐 Resize to signature box
                const finalCanvas = resizeToSignatureBox(croppedCanvas);

                // 🔹 Convert to transparent PNG
                finalCanvas.toBlob((blob) => {
                    if (!blob) return;

                    const transparentFile = new File(
                        [blob],
                        "signature.png",
                        { type: "image/png" }
                    );

                    setSignatureFile(transparentFile);
                    setPreview(URL.createObjectURL(transparentFile));
                }, "image/png");
            };
        };

        reader.readAsDataURL(file);
    };




    const handleSignatureChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            setFileSizeError(prev => ({
                ...prev,
                signature: 'File size must be less than 20 MB',
            }));
            return;
        }
        if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
            setFileSizeError(prev => ({
                ...prev,
                signature: 'Only JPG or PNG images are allowed',
            }));
            return;
        }

        setFileSizeError(prev => ({ ...prev, signature: undefined }));
        setErrors(prev => ({ ...prev, signature: false }));

        removeBackgroundAndFixSize(file);
    };
    const getTypedSignatureFile = async (): Promise<File | null> => {
        if (!typedSigRef.current || !fullName) return null;

        const canvas = await html2canvas(typedSigRef.current, {
            backgroundColor: null, // 🔥 TRANSPARENT
            scale: 2,
        });

        const dataUrl = canvas.toDataURL("image/png");
        return dataURLtoFile(dataUrl, "image/png", "signature.png");
    };
    if (isSubmittingForm) return <PreloaderWrapper />
    else if (isLinkExpired) return <ExpiredLink />;

    if (isSubmitting) return <PreloaderWrapper />
    else if (showSuccess) return (
        <div className='hipaa-wrapper success-page-wrapper'>
            <div className='hipaa-card success-card'>
                <div className="success-iconWrapper">
                    <img src={request_guidance} alt="View" width={140} height={140} />
                </div>

                <h1 className='success-title'>
                    HIPAA Authorization Signed Successfully!
                </h1>

                <p className='success-subtitle'>
                    We've sent an email to {orgName} notifying them that you've submitted <br /> your authorization.
                </p>

                <button className="submit-btn">
                    <a href={`${process.env.REACT_APP_BASE_API_URL}/patient`} className='text-white' target="_blank" rel="noopener noreferrer">Explore ChartRequest</a>
                </button>
            </div>
        </div>
    )
    return (
        <div className="hipaa-container sign-digital-signature-wrapper">
            <div className="sign-header">
                <h2 className="title">Digitally Sign HIPAA Authorization</h2>
                <p className="subtitle">
                    Please type, draw, or upload your signature to sign the authorization.
                    Upload your government ID if it’s requested.
                </p>
            </div>

            <div className="content hippa-main-wrapper">
                {/* LEFT – PDF VIEWER */}
                <div className="pdf-viewer">
                    {pdfUrl ? (
                        <iframe
                            src={`${pdfUrl}#navpanes=0`}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <PreloaderWrapper />
                    )}
                </div>

                {/* RIGHT – SIGNATURE FORM */}
                <div className="form-section">
                    {/* Digital Signature */}
                    <div className="card">
                        <div className="sign-card-header">
                            <div className="title">
                                <img src={image9} alt='' /> <span>Add Digital Signature</span>
                            </div>

                            <div
                                className="options"
                                style={isSignatureVerified ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
                            >
                                <label>
                                    <Radio
                                        name="paymentMethod"
                                        value="draw"
                                        labelText="Type/Draw"
                                        checked={uploadType === 'draw'}
                                        onChange={(e: any) => handleUploadTypeChange(e.target.value)}
                                    />
                                </label>

                                <label>
                                    <Radio
                                        name="paymentMethod"
                                        value="signature"
                                        labelText="Upload Signature"
                                        checked={uploadType === 'signature'}
                                        onChange={(e: any) => handleUploadTypeChange(e.target.value)}

                                    />
                                </label>
                            </div>

                        </div>
                        {uploadType === 'signature' ? (<>
                            <div className={`upload-box-front-back ${errors.signature || fileSizeError.signature ? 'error-border' : ''}`}>
                                {!preview ? (
                                    <div className="upload-content-front-back upload-content">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_8155_26658)">
                                                    <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" fill="#00155A" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8155_26658">
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <p>
                                            Drop your file here or <span>Browse</span>
                                        </p>
                                        <small>Supports JPG, PNG document</small>
                                        <input
                                            type="file"
                                            className="upload-auth-input"
                                            accept="image/png,image/jpeg"
                                            onChange={handleSignatureChange}
                                        />
                                        {fileSizeError.signature && (
                                            <span className="upload-auth-input">{fileSizeError.signature}</span>
                                        )}
                                    </div>
                                ) : (
                                    <div className="signature-preview">
                                        <img src={preview} alt="Signature Preview" width="100%" height="100%" />

                                        {!isSignatureVerified && (
                                            <button
                                                className="signature-delete-btn"
                                                onClick={() => {
                                                    setPreview(null);
                                                    setSignatureFile(null);
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <g clip-path="url(#clip0_8499_84735)">
                                                        <path d="M5.83464 3.33073V1.66406H14.168V3.33073H18.3346V4.9974H16.668V17.4974C16.668 17.7184 16.5802 17.9304 16.4239 18.0867C16.2676 18.2429 16.0556 18.3307 15.8346 18.3307H4.16797C3.94696 18.3307 3.73499 18.2429 3.57871 18.0867C3.42243 17.9304 3.33464 17.7184 3.33464 17.4974V4.9974H1.66797V3.33073H5.83464ZM5.0013 4.9974V16.6641H15.0013V4.9974H5.0013ZM7.5013 7.4974H9.16797V14.1641H7.5013V7.4974ZM10.8346 7.4974H12.5013V14.1641H10.8346V7.4974Z" fill="#E7322C" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_8499_84735">
                                                            <rect width="20" height="20" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        )}
                                    </div>
                                )}

                            </div>
                        </>) : (
                            <>
                                <div className="field">
                                    <label>Full Name</label>
                                    <input
                                        type="text"
                                        placeholder={errors.fullName ? 'This is a required field' : 'Required'}
                                        value={fullName}
                                        className={errors.fullName ? 'error-border' : ''}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            // Allow only alphabets, space, ' and -
                                            const nameRegex = /^[A-Za-z\s'-]*$/;

                                            if (nameRegex.test(value)) {
                                                setFullName(value);
                                                setErrors(prev => ({ ...prev, fullName: false }));
                                            }
                                        }}
                                    />

                                </div>

                                <div className="toggle-row">
                                    <span>Type</span>

                                    <label className="switch">
                                        <input type="checkbox" onChange={(e) => setType(e.target.checked)} />
                                        <span className="slider" />
                                    </label>

                                    <span>Draw</span>
                                </div>
                                {isDrawMode ? (
                                    <>
                                        <div className='signature-instructions'>
                                            <InputLabel text='Draw *' /> {errors.signature && (
                                                <span className='text-red'>Please draw a signature.</span>
                                            )}
                                            {isSigned && (
                                                <div className='float-right'>
                                                    <span role='button' className='clear-file-name' onClick={() => {
                                                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                                        signRef?.clear(); setSigned(false)
                                                    }}>Clear</span>
                                                </div>
                                            )}
                                        </div>
                                        <div
                                            className={`signature-previewContainer ${errors.signature ? 'error-border' : ''
                                                }`}
                                        >
                                            <SignatureCanvas
                                                penColor="black"
                                                canvasProps={{ className: 'signCanvas' }}
                                                ref={i => (signRef = i)}
                                                onBegin={() => {
                                                    setSigned(true)
                                                    setErrors(prev => ({ ...prev, signature: false }))
                                                }}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <div className="field">
                                        <label>Preview {errors.fullName ? (<span className='error-text'>Signature is required to submit the form</span>) : null}</label>
                                        <div className={`preview-box ${errors.fullName ? 'brd-red' : ''}`}>
                                            <span className="sig_icons">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="66" viewBox="0 0 25 66" fill="none">
                                                    <path d="M25 1H11C5.47715 1 1 5.47715 1 11V55C1 60.5228 5.47715 65 11 65H25" stroke="#4062E5" stroke-width="2" />
                                                </svg>
                                            </span>
                                            <span className="signed-by">Signed By:</span>
                                            <div
                                                ref={typedSigRef}
                                                style={{
                                                    position: 'absolute',
                                                    left: '6px',
                                                    top: 50,
                                                    background: 'transparent',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                <span className="signature-txt">{fullName}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                    </div>


                    {/* Govt ID Upload */}
                    <div className="upload-section">
                        <div className="upload-header">
                            <img src={image10} alt="" />
                            Upload Govt. ID (Front, Back) -{' '}
                            <span className="optional_txt">{government_id}</span>
                        </div>

                        <div className="upload-body grid-2">
                            {renderUploadBox('Gov ID Front', govtIdFiles.front, 'front')}
                            {renderUploadBox('Gov ID Back', govtIdFiles.back, 'back')}
                        </div>
                    </div>

                    {/* Authorization */}
                    <div className="checkbox-row">
                        <label className="auth-checkbox-wrapper">
                            <input
                                type="checkbox"
                                checked={isAuthorized}
                                onChange={(e) => {
                                    setIsAuthorized(e.target.checked);
                                    setErrors((prev) => ({ ...prev, authorization: false }));
                                }}
                                className="auth-checkbox-input"
                            />

                            <span
                                className={`auth-checkbox-custom ${errors.authorization && !isAuthorized ? "checkbox-error" : ""
                                    }`}
                            />
                        </label>
                        <p>
                            I authorize <strong>{orgName || 'Law Firm'}</strong> to assist me in completing this HIPAA Authorization, including placing my signature/date on the form as I have provided, filling clearly indicated missing fields (e.g., DOB, MRN, date ranges) at my direction, and submitting this authorization to the designated providers to obtain my records.
                        </p>
                    </div>
                    {errors.authorization && !isAuthorized && (
                        <span className="text-red">You must authorize the law firm to proceed</span>
                    )}
                    {/* Submit */}
                    <button
                        className={`submit-btn ${isSubmittingForm ? 'disabled' : ''}`}
                        onClick={handleFinalSubmit}
                        disabled={isSubmittingForm}
                    >
                        {isSubmittingForm ? 'Submitting...' : 'Submit'}
                    </button>
                </div>
            </div>
        </div>
    );
}
